/**
 * @file サポーター登録での生年月日変更
 *
 */
'use strict'

import Common from "../../Utils/Common"

/**
 * @classname SelectExternalRegistration
 * @classdesc サポーター登録での生年月日変更
 */
export default class SelectExternalRegistration {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.select-external-registration')
	 */
	constructor($e) {
		console.log('SelectExternalRegistration.constructor')
		this._$e = $e
		this._$e.on('change', () => this.onChange());
		this._$target = $('#parent-agree-wrap');
	}


	/**
	 * changeのコールバック
	 *
	 * @memberof SelectExternalRegistration
	 * @return {undefined}
	 */
	onChange() {
		console.log('SelectExternalRegistration.onChange');
		let cnt = 0;
		$('.select-external-registration').each((idx, e) => {
			const $e = $(e);
			if($e.val() !== '') cnt ++;
		});
		if(cnt === 3){
			const year = $('.select-external-registration.year').val();
			const month = $('.select-external-registration.month').val();
			const day = $('.select-external-registration.day').val();
			const birthday = {
				year: year,
				month: month,
				day: day
			}
			const age = this.getAge(birthday);
			console.log(`age is ${age}`);
			if(age < 18){
				this._$target.show();
				if($('#agree-policy').prop('checked') && $('#parent-agree').prop('checked')){
					$('#btn-registration').prop('disabled', false);
				}else{
					$('#btn-registration').prop('disabled', true);
				}
			}else{
				this._$target.hide();
				if($('#agree-policy').prop('checked')){
					$('#btn-registration').prop('disabled', false);
				}else{
					$('#btn-registration').prop('disabled', true);
				}
			}
		}
	}

	/**
	 * 年齢を取得する
	 *
	 * @memberof SelectExternalRegistration
	 * @return {undefined}
	 */
	getAge(birthday) {
		console.log('SelectExternalRegistration.getAge');
		const today = new Date();
		const thisYearsBirthday = new Date(today.getFullYear(), parseInt(birthday.month) - 1, parseInt(birthday.day));
		let age = today.getFullYear() - birthday.year;
		console.log(today);
		console.log(thisYearsBirthday);
		if(today < thisYearsBirthday){
			age--;
		}
		return age;
	};
}
